import { render } from "./DefaultNav.vue?vue&type=template&id=5ab5c9e2"
import script from "./DefaultNav.vue?vue&type=script&lang=js"
export * from "./DefaultNav.vue?vue&type=script&lang=js"
script.render = render

export default script